module.exports = new __parcel__URL__("course_4.a9712e9e.jpg").toString();